import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, styled } from '@mui/material'
import WarningPrompt from '../WarningPrompt'

const StyledDialog = styled(Dialog)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
}))

const WarningModal = ({
    title,
    description,
    open,
    proceed,
    proceeding,
    cancel,
    yesLabel,
    noLabel,
}) => {
    return (
        <StyledDialog
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={cancel}
            closeAfterTransition
        >
            <WarningPrompt
                title={title}
                description={description}
                cancel={cancel}
                proceed={proceed}
                proceeding={proceeding}
                yesLabel={yesLabel}
                noLabel={noLabel}
            />
        </StyledDialog>
    )
}

WarningModal.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    proceed: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
}

export default WarningModal
